import axios from 'axios'
import {API_BASE} from '../config'

import {
  ALL_SELLPOINTS,
  ALL_SELLPOINTS_SUCCESS,
  ALL_PRODUCTS,
  ALL_PRODUCTS_SUCCESS,
} from './mutation-types'

//sellpoint
export const sellpointActions = {
  allSellpoints ({commit}) {
    commit(ALL_SELLPOINTS)
    axios.get(`${API_BASE}/businesses`,{
        headers: {
            'Api-Token': this.apiToken
         }
    }).then(response => {
      commit(ALL_SELLPOINTS_SUCCESS, response.data)
    })
  },

}

//product
export const productActions = {
  allProducts ({commit}) {
    commit(ALL_PRODUCTS)
    axios.get(`${API_BASE}/products`,{
        headers: {
            'Api-Token': this.apiToken
         }
    }).then(response => {
      commit(ALL_PRODUCTS_SUCCESS, response.data)
    })
  },

}

//CART





// WEBPACK FOOTER //
// ./src/store/actions.js